import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import { TWStaticSubscribeCard } from '../../cards/TWStaticSubscribeCard/TWStaticSubscribeCard'

export const StaticSubscribePromoCardRegistration = createRegisterableComponent(
    'tw-subscribe-promo-card',
    () => <TWStaticSubscribeCard />,
)
